import React, { Component } from "react";
import SlotsCourasel from "./SlotsCourasel";
import Images from "../Images";
import SlotsHeading from "./SlotsHeading";
import SlotsMainSection from "./SlotsMainSection";
import {
  getJackpots,
} from "../../../redux/actions/slotsActions";
import { setPropsMath } from "../../../redux/actions/appActions";
import {
  jackpotConnect,
  jackpotDisconnect,
} from "../../../redux/actions/singnalrActions";
import { connect } from "react-redux";
import { Drawer } from "antd";
import TopGamesDrawerIcon from "./TopGamesDrawerIcon";
import TopGames from "./TopGames";
import NewGames from "./NewGames";

export class SlotsCategories extends Component {
  state = {
    categoryId: this.props.match.params.categoryId,
    openTopGamesDrawer: false,
  };
  componentDidMount() {
    const {
      getJackpots,
      jackpotConnect,
      setPropsMath,
    } = this.props;
    getJackpots();
    setPropsMath();

    jackpotConnect();
  }
  componentWillUnmount() {
    const { jackpotDisconnect } = this.props;
    jackpotDisconnect();
  }
  updateCategory = (id) => {
    const {history}=this.props;
    history.push(`/slots/${id}`)
    this.setState({
      categoryId: id,
    });
  };
  openTopGamesDrawer = () => {
    this.setState({
      openTopGamesDrawer: !this.state.openTopGamesDrawer,
    });
  };
  render() {
    const {
      categories,
      slotsFrontPageTemplates,
      loading,
      slotsGames,
      slotsGamesCategories,
      history,
      match
    } = this.props;
      // Top Games
      const topGamesInfo =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return ((item.rowId == 3 && item.columId == 2) || (item.sliderCategoryId != 0));
      });
    const topGamesInfoCategories =
      topGamesInfo &&
      topGamesInfo.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => (game.categoryId == topGamesInfo[0].sliderCategoryId));
    const topGamesInfoGames= topGamesInfoCategories && topGamesInfoCategories.length > 0 && topGamesInfoCategories[0].slotsGames && topGamesInfoCategories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const topGamesInfoType = topGamesInfo && topGamesInfo.length > 0 && topGamesInfo[0].imageTypeId
    const topGamesTitle =
    slotsGamesCategories &&
    topGamesInfoGames &&
    topGamesInfoGames.length > 0 &&
    slotsGamesCategories.filter(
      (category) => category.categoryId == topGamesInfoGames[0].categoryId
    );
    //
    //
    // row 1 col2
    const row1Col2 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return ((item.rowId == 1 && item.columId == 2 )|| (item.rowId == 1 && item.columId == 1));
      });
    const row1Col2Categories =
      row1Col2 &&
      row1Col2.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => game.categoryId == row1Col2[0].categoryId);
    const row1Col2Games= row1Col2Categories && row1Col2Categories.length > 0 &&  row1Col2Categories[0].slotsGames && row1Col2Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const row1Col2ImageType = row1Col2 && row1Col2.length > 0 && row1Col2[0].imageTypeId
    //

    // row 2 col 1
    const row2Col1 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 2 && item.columId == 1;
      });
    const isRow2Col1Tabs =
      row2Col1 && row2Col1.length > 0 && row2Col1[0].categoryId == 0;
    const row2Col1Tabs = slotsGamesCategories && slotsGamesCategories.filter(item=> item.categoryIsTab);
    const row2Col1Games =
      !isRow2Col1Tabs &&
      row2Col1 &&
      row2Col1.length > 0 &&
      slotsGames &&
      slotsGames
        .filter((game) => game.categoryId == row2Col1[0].categoryId)
        .sort((a, b) => a.gameOrder < b.gameOrder);
    const row2Col1Info =
      slotsGamesCategories &&
      row2Col1 &&
      row2Col1.length > 0 &&
      slotsGamesCategories.filter(
        (category) => category.categoryId == row2Col1[0].categoryId
      );
    //

       // row 8 col1
       const row8Col1 =
       slotsFrontPageTemplates &&
       slotsFrontPageTemplates.filter((item) => {
         return item.rowId == 8 && item.columId == 1;
       });
     const row8Col1Categories =
       row8Col1 &&
       row8Col1.length > 0 &&
       slotsGamesCategories &&
       slotsGamesCategories
         .filter((game) => game.categoryId == row8Col1[0].categoryId)
 
     const row8Col1Games= row8Col1Categories && row8Col1Categories.length > 0 &&   row8Col1Categories[0].slotsGames && row8Col1Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
     const row8Col1ImageType = row8Col1 && row8Col1.length > 0 && row8Col1[0].imageTypeId
     const row8Col1Info =
       slotsGamesCategories &&
       row8Col1 &&
       row8Col1.length > 0 &&
       slotsGamesCategories.filter(
         (category) => category.categoryId == row8Col1[0].categoryId
       );
 
     //
    // row 9 col1
    const row9Col1 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 9 && item.columId == 1;
      });
    const row9Col1Categories =
      row9Col1 &&
      row9Col1.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => game.categoryId == row9Col1[0].categoryId)
        
    const row9Col1Games= row9Col1Categories && row9Col1Categories.length > 0 &&  row9Col1Categories[0].slotsGames && row9Col1Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const row9Col1ImageType = row9Col1 && row9Col1.length > 0 && row9Col1[0].imageTypeId
    const row9Col1Info =
      slotsGamesCategories &&
      row9Col1 &&
      row9Col1.length > 0 &&
      slotsGamesCategories.filter(
        (category) => category.categoryId == row9Col1[0].categoryId
      );
    //
    // Additional Rows
    const additionalRows =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return (item.rowId > 9 && item.categoryId > 0);
      });
    const additionalRowsCategories=[]
    additionalRows &&
    additionalRows.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .map((game) => additionalRows.map(singleRow=> {
          if(game.categoryId == singleRow.categoryId){
            additionalRowsCategories.push(game) 
        }} ) )        

    //

    const gameGroup =
      this.state.categoryId && slotsGames
        ? slotsGames
            .filter((game) => game.categoryId == this.state.categoryId)
            .sort((a, b) => a.gameOrder < b.gameOrder)
        : [];
    return (
      <div className="slots-categories">
        {loading ? (
          <div className="events">
            {/* <div className="skeleton">
            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>
          </div> */}
            <div className="lds-parent-ring">
              <div className="lds-ring">
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          </div>
        ) : (
          <>
            <SlotsHeading row1Col2Games={row1Col2Games} history={history} row1Col2ImageType={row1Col2ImageType} slidesToShow={(row1Col2 && row1Col2.length > 0 && row1Col2[0].displayGames) ? (row1Col2[0].displayGames): 1} />
            <SlotsCourasel
              title={row2Col1Info && row2Col1Info[0].categoryName}
              slides={isRow2Col1Tabs ? row2Col1Tabs : row2Col1Games}
              slidesToShow={(row2Col1 && row2Col1.length > 0 && row2Col1[0].displayGames) ? (row2Col1[0].displayGames) : 6}
              history={history}
              type={isRow2Col1Tabs ? "tabs" : "images"}
              scatter={true}
              categoryId={this.state.categoryId}
              updateCategory={this.updateCategory}
              imageSpecialTypeId={row2Col1 && row2Col1.length > 0 && row2Col1[0].imageSpecialTypeId}
              largeSlideNumber={row2Col1 && row2Col1.length > 0 && row2Col1[0].imageSpecialSizeOrder}
            />
            {/*  */}

            <SlotsMainSection
              categoryId={this.state.categoryId}
              gameGroup={gameGroup}
              updateCategory={this.updateCategory}
              history={history}
              topGamesInfoType={topGamesInfoType} 
              match={match}
            />
            {/*  */}
            {this.state.categoryId == 0 && (
              <>
                           <SlotsCourasel
                  title={row8Col1Info && row8Col1Info[0].categoryName}
                  autoPlay={false}
                  slides={row8Col1Games}
                  slidesToShow={(row8Col1 && row8Col1.length> 0 && row8Col1[0].displayGames) ? (row8Col1[0].displayGames) : 4}
                  history={history}
                  type={"images"}
                  updateCategory={this.updateCategory}
                  categoryId={row8Col1Info && row8Col1Info[0].categoryId}
                  imageType={row8Col1ImageType}
                  imageSpecialTypeId={row8Col1 && row8Col1.length > 0 && row8Col1[0].imageSpecialTypeId}
                  largeSlideNumber={row8Col1 && row8Col1.length > 0 && row8Col1[0].imageSpecialSizeOrder}
                />

                <SlotsCourasel
                  title={row9Col1Info && row9Col1Info[0].categoryName}
                  autoPlay={false}
                  slides={row9Col1Games}
                  slidesToShow={(row9Col1 && row9Col1.length > 0 && row9Col1[0].displayGames) ? (row9Col1[0].displayGames) : 6}
                  type={"images"}
                  history={history}
                  updateCategory={this.updateCategory}
                  categoryId={row9Col1Info && row9Col1Info[0].categoryId}
                  imageType={row9Col1ImageType}
                  imageSpecialTypeId={row9Col1 && row9Col1.length > 0 && row9Col1[0].imageSpecialTypeId}
                  largeSlideNumber={row9Col1 && row9Col1.length > 0 && row9Col1[0].imageSpecialSizeOrder}
                />

                {additionalRowsCategories && additionalRowsCategories.map(row=>{
                  return (
                    <SlotsCourasel
                    title={row.categoryName}
                    autoPlay={false}
                    slides={row.slotsGames && row.slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)}
                    slidesToShow={additionalRows.filter(item=>item.categoryId == row.categoryId).length > 0 ? additionalRows.filter(item=>item.categoryId == row.categoryId)[0].displayGames : 5}
                    type={"images"}
                    history={history}
                    updateCategory={this.updateCategory}
                    categoryId={row.categoryId}
                    imageType={additionalRows.filter(item=>item.categoryId == row.categoryId).length > 0 && additionalRows.filter(item=>item.categoryId == row.categoryId)[0].imageTypeId}
                    imageSpecialTypeId={additionalRows.filter(item=>item.categoryId == row.categoryId).length > 0 && additionalRows.filter(item=>item.categoryId == row.categoryId)[0].imageSpecialTypeId}
                    largeSlideNumber={additionalRows.filter(item=>item.categoryId == row.categoryId).length > 0 && additionalRows.filter(item=>item.categoryId == row.categoryId)[0].imageSpecialSizeOrder}
                  />
                  )
                })}
                {/* <DrawerIcon /> */}
                <TopGamesDrawerIcon
                  openTopGamesDrawer={this.openTopGamesDrawer}
                />
                <Drawer
                  width={280}
                  placement="right"
                  className="top-games-drawer"
                  closable={true}
                  destroyOnClose
                  onClose={() => this.openTopGamesDrawer()}
                  visible={this.state.openTopGamesDrawer}
                >
                  <TopGames games={topGamesInfoGames} history={history} topGamesInfoType={topGamesInfoType} title={topGamesTitle && topGamesTitle[0].categoryName}/>
                </Drawer>
              </>
            )}
          </>
        )}
      </div>
    );
  }
}
const mapStateToProps = (_, initialProps) => (state) => {
  return {
    slotsGames: state.slots.slotsGames,
    loading: state.slots.loading,
    categories: state.slots.categories,
    slotsFrontPageTemplates: state.slots.slotsFrontPageTemplates,
    slotsGamesCategories: state.slots.slotsGamesCategories,
    config: state.slots.config,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPropsMath: () => dispatch(setPropsMath()),
    jackpotConnect: () => dispatch(jackpotConnect()),
    jackpotDisconnect: () => dispatch(jackpotDisconnect()),
    getJackpots: () => dispatch(getJackpots()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SlotsCategories);
